export enum PermissionRole {
  // 游客
  Guest = 0,
  // 总渠道负责人
  HeadChannelManager = 1,
  // 渠道负责人
  ChannelManager = 2,
  // 团队成员
  Members = 3,
}

export enum UserAccountType {
  // 渠道商账号
  Broker = 'BROKER_VIEW',
  // 客户账号
  Customer = 'CUSTOMER_VIEW',
  // 超级管理员
  SuperAdmin = 'SUPER_VIEW',
  // 客服账号
  CustomerService = 'CUSTOMER_SERVICE_VIEW',
  // BU账号
  Bu = 'BU_VIEW',
}

export enum UserViewType {
  // BU
  Bu = 'BU_VIEW',
  // 渠道商
  Broker = 'BROKER_VIEW',
}

export enum UserViewMode {
  // 渠道商
  Broker = 'BROKER_VIEW',
  // BU
  Bu = 'BU_VIEW',
}

// 平台角色
export enum PlatformRole {
  // 默认
  Default = 'PLATFORM_ROLE_UNSPECIFIED',
  // 销售 -- 只能选择 Broker 角色类型
  Sales = 'PLATFORM_ROLE_SALES',
  // 客户
  Customer = 'PLATFORM_ROLE_CUSTOMER',
  // 其他
  Other = 'PLATFORM_ROLE_OTHER',
}

export interface UserAuthState {
  name: string
  avatar: string
  tenant_id: string
  user_id: string
  dept_id: string[]
  role_id: string[]
  role_name: string[]
  enterprise_id: string[]
  current_enterprise: string
  account: string
  user_name: string
  nick_name: string
  access_token: string // 鉴权的token
  token_type: string
  expires_in: number
  license: string
  simulated_login_flag: number
  simulated_login_ticket: string
  current_enterprise_name: string
  current_enterprise_name_cn: string
  email: string
  permissionGroup: string[]
  // 是否是管理员
  is_admin: boolean
  highest_authority_organization_id: string
  role_permission: PermissionRole
  // 用户账号类型
  user_account_types: UserAccountType[]
  // BU ID列表
  bu_ids: string[]
  user_view_types: UserViewType[]
}

// 0: 未登录 1: 登录中 2: 登录成功 3: 登录失效
export type LoginStatus = 0 | 1 | 2 | 3
